export default "__VITE_ASSET__B9d_8mmo__"